import React, { useEffect, useState, useCallback } from 'react';
import { NavLink, Link } from 'react-router-dom';
import {
  NUMEROLOGY_BRAND_LOGO_URL,
  NUMEROLOGY_BRAND_TITLE,
  NUMEROLOGY_HOME_PATH,
} from './numerologyShellConstants';

const NAV = [
  { to: NUMEROLOGY_HOME_PATH, label: 'Home', end: true },
  { to: '/numerology/study', label: 'Course', end: false },
  { to: '/numerology/report', label: 'Report', end: false },
];

export default function NumerologyHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const onScroll = useCallback(() => {
    setScrolled(window.scrollY > 8);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`amm-num-header${scrolled ? ' amm-num-header--scrolled' : ''}`}>
      <div className="amm-num-header__inner">
        <Link
          className="numerology-brand"
          to={NUMEROLOGY_HOME_PATH}
          onClick={closeMenu}
        >
          <img
            className="numerology-brand__logo"
            src={NUMEROLOGY_BRAND_LOGO_URL}
            alt="Astral Moon Magic"
            decoding="async"
            loading="eager"
          />
          <span className="brand-text">{NUMEROLOGY_BRAND_TITLE}</span>
        </Link>

        <div className="amm-num-header__actions">
          <nav className="amm-num-header__nav" aria-label="Numerology">
            {NAV.map(({ to, label, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  `amm-num-header__link${isActive ? ' amm-num-header__link--active' : ''}`
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>

          <button
            type="button"
            className="amm-num-menu-toggle"
            aria-expanded={menuOpen}
            aria-controls="amm-num-nav-mobile"
            onClick={() => setMenuOpen((o) => !o)}
          >
            <span className="visually-hidden">{menuOpen ? 'Close menu' : 'Open menu'}</span>
            <span className="amm-num-menu-toggle__bars" aria-hidden>
              <span />
              <span />
              <span />
            </span>
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div
          className="amm-num-drawer"
          id="amm-num-nav-mobile"
          role="dialog"
          aria-modal="true"
          aria-label="Numerology menu"
          onClick={closeMenu}
        >
          <div className="amm-num-drawer__panel" onClick={(e) => e.stopPropagation()}>
            {NAV.map(({ to, label, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  `amm-num-drawer__link${isActive ? ' amm-num-drawer__link--active' : ''}`
                }
                onClick={closeMenu}
              >
                {label}
              </NavLink>
            ))}
          </div>
        </div>
      ) : null}
    </header>
  );
}
